var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "邀请他人审阅",
        visible: _vm.cooperVisi,
        width: "40%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.cooperVisi = $event
        }
      }
    },
    [
      _vm.darfPhoneList.length !== 0
        ? _c(
            "el-form",
            {
              ref: "dynamicValidateForm",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                model: _vm.dynamicValidateForm,
                "label-width": "100px",
                size: "small"
              }
            },
            _vm._l(_vm.darfPhoneList, function(item, i) {
              return _c(
                "el-form-item",
                {
                  key: item.i,
                  attrs: {
                    label: "协作人" + (i + 1) + ":",
                    "label-width": "100px",
                    size: "small"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "item-sty" },
                    [
                      _c("el-input", {
                        style: {
                          "margin-right": "10px",
                          width: _vm.inputWidth
                        },
                        attrs: { value: item.mobilePhone, readonly: "" }
                      }),
                      _c("el-input", {
                        style: { width: _vm.inputWidth },
                        attrs: { value: item.userName, readonly: "" }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "dynamicValidateForm",
          staticStyle: { "margin-top": "10px" },
          attrs: {
            model: _vm.dynamicValidateForm,
            "label-width": "100px",
            size: "small"
          }
        },
        _vm._l(_vm.dynamicValidateForm.domains, function(domain, index) {
          return _c(
            "el-form-item",
            {
              key: domain.key,
              attrs: {
                label: "添加协作人",
                prop: "domains." + index + ".mobile",
                rules: domain.r_mobile
              }
            },
            [
              _c(
                "div",
                { staticClass: "item-sty" },
                [
                  _c("el-input", {
                    style: { "margin-right": "10px", width: _vm.inputWidth },
                    attrs: { placeholder: "协作人手机号" },
                    model: {
                      value: domain.mobile,
                      callback: function($$v) {
                        _vm.$set(domain, "mobile", $$v)
                      },
                      expression: "domain.mobile"
                    }
                  }),
                  _c("el-input", {
                    style: { width: _vm.inputWidth },
                    attrs: { placeholder: "协作人名称" },
                    model: {
                      value: domain.name,
                      callback: function($$v) {
                        _vm.$set(domain, "name", $$v)
                      },
                      expression: "domain.name"
                    }
                  }),
                  _c("i", {
                    staticClass: "el-icon-circle-plus-outline",
                    on: { click: _vm.addDomain }
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.dynamicValidateForm.domains.length > 1,
                        expression: "dynamicValidateForm.domains.length > 1"
                      }
                    ],
                    staticClass: "el-icon-delete",
                    on: {
                      click: function($event) {
                        return _vm.removeDomain(domain)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        }),
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function($event) {
                  return _vm.submitForm("dynamicValidateForm")
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-076bccb1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-076bccb1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/cooperateWith/cooperPup.vue
// module id = Oir1
// module chunks = 2 3 6 8 49 113